import { useState } from 'react';
import { signUp, confirmSignUp, resendCode, signIn } from '../auth';

export default function Signup({ onSignedUp, onGoToLogin }) {
  const [step, setStep] = useState('signup'); // signup | verify
  const [form, setForm] = useState({ name: '', email: '', password: '', confirm: '' });
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSignup = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) { setError('Passwords do not match'); return; }
    if (form.password.length < 8) { setError('Password must be at least 8 characters'); return; }
    setError(''); setLoading(true);
    try {
      await signUp(form.email, form.password, form.name);
      setStep('verify');
    } catch (err) {
      setError(err.message || 'Signup failed');
    } finally { setLoading(false); }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await confirmSignUp(form.email, code);
      // Auto sign in after verification
      const token = await signIn(form.email, form.password);
      localStorage.setItem('idToken', token);
      onSignedUp();
    } catch (err) {
      setError(err.message || 'Verification failed');
    } finally { setLoading(false); }
  };

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="logo">
          <div style={{ fontSize: 40 }}>💰</div>
          <h2>DuesTrack</h2>
          <p>{step === 'signup' ? 'Create your account' : 'Verify your email'}</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        {step === 'signup' ? (
          <form onSubmit={handleSignup}>
            <div className="form-group">
              <label>Your Name</label>
              <input value={form.name} onChange={set('name')} required autoFocus placeholder="Jane Smith" />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" value={form.email} onChange={set('email')} required placeholder="you@example.com" />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input type="password" value={form.password} onChange={set('password')} required placeholder="Min 8 characters" />
            </div>
            <div className="form-group">
              <label>Confirm Password</label>
              <input type="password" value={form.confirm} onChange={set('confirm')} required />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: 8 }} disabled={loading}>
              {loading ? 'Creating account…' : 'Create Account'}
            </button>
            <p style={{ textAlign: 'center', marginTop: 16, fontSize: 14, color: 'var(--muted)' }}>
              Already have an account?{' '}
              <span style={{ color: 'var(--navy)', cursor: 'pointer', fontWeight: 600 }} onClick={onGoToLogin}>Sign in</span>
            </p>
          </form>
        ) : (
          <form onSubmit={handleVerify}>
            <p style={{ fontSize: 14, color: '#374151', marginBottom: 16 }}>
              We sent a verification code to <strong>{form.email}</strong>. Enter it below to activate your account.
            </p>
            <div className="form-group">
              <label>Verification Code</label>
              <input value={code} onChange={e => setCode(e.target.value)} required autoFocus placeholder="123456"
                style={{ fontSize: 24, letterSpacing: 8, textAlign: 'center' }} />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
              {loading ? 'Verifying…' : 'Verify & Continue'}
            </button>
            <p style={{ textAlign: 'center', marginTop: 12, fontSize: 13, color: 'var(--muted)' }}>
              Didn't get it?{' '}
              <span style={{ color: 'var(--navy)', cursor: 'pointer', fontWeight: 600 }}
                onClick={() => resendCode(form.email).catch(() => {})}>Resend code</span>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
